import React from 'react';
import { Col, Card, Carousel } from 'react-bootstrap';

interface Image {
  src: string; 
  alt: string;
}
interface PropsType {
  images: Image[];
  onClick: () => void;
}



const DashboardBanner: React.FC<PropsType> = ({ images, onClick }) => {
  
  return (
    <Col md={12} className='pr-2 pt-2'>
  <Carousel controls={false} indicators={false} interval={3000} pause={false} className='d-none d-sm-block'>
    {images?.map((img, index) => (
      <Carousel.Item key={index}>
        <Card className='card-banner'>
          <Card.Img 
            variant='top' 
            src={img?.src}  
            alt={img?.alt} 
            onClick={onClick}
            style={{ cursor: 'pointer' }} 
          />
        </Card>
      </Carousel.Item>
    ))}
  </Carousel>
</Col>

  );
};

export default DashboardBanner;
